import { mapGetters } from 'vuex';

export const initBookingChannel = {
  data: () => ({
    cookieEnabled: false,
    bookingChannelConfigured: false,
  }),
  created() {
    this.cookiesEnabled = navigator.cookieEnabled;

    if (this.cookiesEnabled && window.bookingChannelConfig) {
      this.bookingChannelConfigured = true;
      this.$store.commit('bookingChannel/setBookingChannelConfig', window.bookingChannelConfig);
    }
  },
};

export const bookingChannelComputed = {
  computed: {
    ...mapGetters({
      authCallbackUrl: 'bookingChannel/authCallbackUrl',
      companyName: 'bookingChannel/companyName',
      id: 'bookingChannel/id',
      logoURL: 'bookingChannel/logoURL',
      oidcClientId: 'bookingChannel/oidcClientId',
      postLogoutUrl: 'bookingChannel/postLogoutUrl',
      currencySymbol: 'bookingChannel/currencySymbol',
      fleets: 'bookingChannel/fleets',
      multiFleetEnabled: 'bookingChannel/multiFleetEnabled',
    }),
  },
};
